import Stat from '@fe/common/lib/stat';
import { sendStat } from 'utils/common';

// 模板市场点击搜索结果下的免费模板
export function sendToClickSearchTemplate() {
  sendStat(
    'RP_STORE',
    '模版市场',
    '搜索结果页免费模板按钮点击',
    Stat.ACTION_CLICK,
    {
      id: 'web_mobanmarket_searchreturn_click',
    }
  );
}

/**
 * 搜索结果页模板分类按钮点击
 * @param category number
 * 0：全部
 * 1：翻页
 * 2：长页
 * 3：短视频
 */
export function sendToClickSearchCategory(category) {
  sendStat(
    'RP_STORE',
    '模版市场',
    '搜索结果页模板分类按钮点击',
    Stat.ACTION_CLICK,
    {
      id: 'web_mobanmarket_searchtpltype_click',
      tpltype: category,
    }
  );
}

/**
 * 点击最热或最新排序
 * @param type number
 * 1：最热
 * 2：最新
 * @param category
 * 2=场景分类页
 * 3=长页分类页
 * 4=视频分类页
 * 9=搜索结果页
 */
export function sendToClickSortType(type, category) {
  sendStat('RP_STORE', '模版市场', '排序方式点击', Stat.ACTION_CLICK, {
    id: 'web_mobanmarket_sort_click',
    sortorder: type,
    category,
  });
}
